import { render, staticRenderFns } from "./courseLxsq.vue?vue&type=template&id=74ee0ab2&scoped=true&"
import script from "./courseLxsq.vue?vue&type=script&lang=js&"
export * from "./courseLxsq.vue?vue&type=script&lang=js&"
import style0 from "./courseLxsq.vue?vue&type=style&index=0&id=74ee0ab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ee0ab2",
  null
  
)

export default component.exports